import { InjectionKey } from 'vue';

import { UseBottomSheet, UseModal } from '../composables';

// Modals
export const MyEmergencyPlanModal: InjectionKey<UseModal> = Symbol();
export const MyEmergencyPlanExitModal: InjectionKey<UseModal> = Symbol();
export const MyEmergencyPlanWarningLevelsModal: InjectionKey<UseModal> = Symbol();
export const MyEmergencyPlanFireDangerRatingsModal: InjectionKey<UseModal> = Symbol();
export const MyEmergencyPlanHigherRiskPeopleModal: InjectionKey<UseModal> = Symbol();
export const MyEmergencyPlanSendPlanModal: InjectionKey<UseModal> = Symbol();

// Bottom sheets
export const EmergencyBottomSheet: InjectionKey<UseBottomSheet> = Symbol();
export const EnableGeolocateBottomSheet: InjectionKey<UseBottomSheet> = Symbol();
